import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { addAlpha } from 'fitify-ui/src/theme/colors'
import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  width: min(80vw, 100%);
  max-width: 380px;
  flex: 0 0 auto;
  flex-direction: column;
  padding: 16px;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.White};
  box-shadow: 0 0 16px 0 ${({ theme }) => addAlpha(theme.colors.Black, 0.08)};
  gap: 12px;
  scroll-snap-align: start;
`

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const StyledStarContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;

  ${StyledIcon} {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.Black};
  }
`
